import { memoize } from "lodash";
import { observable } from "mobx";

import { apiCallGetSilentBannedUsers } from "../../../api/user-api/api-call-get-silent-banned-users";
import { TSilentBannedUser } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import { isDateRangeValid } from "../../../helpers/et3-date-helper";

const toQueryDate = (date: Date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

class SilentBannedUsersStore {
  fromDateInput = observable.box<Date>(new Date());
  toDateInput = observable.box<Date>(new Date());
  silentBannedUsers = observable.box<TSilentBannedUser[]>([]);

  getSilentBannedUsers = async () => {
    if (
      !isDateRangeValid({
        fromDate: this.fromDateInput.get(),
        toDate: this.toDateInput.get(),
        isLimitedToOneMonth: false
      })
    ) {
      return;
    }
    getCoreUIStore().setIsLoading("SILENTLY_BANNED_USERS", true);
    const { status, data, code } = await apiCallGetSilentBannedUsers({
      fromDate: `${toQueryDate(this.fromDateInput.get())} 00:00:00`,
      toDate: `${toQueryDate(this.toDateInput.get())} 23:59:59`
    });
    getCoreUIStore().setIsLoading("SILENTLY_BANNED_USERS", false);
    if (status === "OK") {
      this.silentBannedUsers.set(data);
      return;
    }
    getCorePopUpStore().showAlertMessage(code);
  };
}

const getSilentBannedUsersStore = memoize(() => new SilentBannedUsersStore());
export default getSilentBannedUsersStore;
